import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestRwdacctsGetRes } from "./abst/DtoRequestRwdacctsGetRes";

export class DtoRequestRwdacctsGetResImple extends DtoRequestRwdacctsGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
